import {
  BrowseViewResponseDto,
  ApiError,
  ErrorResponseDto,
  BrowseViewState,
} from '@pro4-erp/core-web';
import env from '@/env';
import { AuditorRegistration } from '../types';

type GetAuditorRegistrationsForMeParams = BrowseViewState & {
  showOnlyValid?: 'true' | 'false';
  showOnlyConfirmed?: 'true' | 'false';
  standardId?: string;
  auditorCategoryId?: string;
};

export const getAuditorRegistrationsForMe = async ({
  page,
  pageSize,
  search,
  sortBy,
  showOnlyValid,
  showOnlyConfirmed,
  standardId,
  auditorCategoryId,
}: GetAuditorRegistrationsForMeParams): Promise<BrowseViewResponseDto<AuditorRegistration>> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-regs/me?${new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      search: search.toString(),
      sortBy: sortBy ? JSON.stringify(sortBy) : '',
      showOnlyValid: showOnlyValid || '',
      showOnlyConfirmed: showOnlyConfirmed || '',
      standardId: standardId || '',
      auditorCategoryId: auditorCategoryId || '',
    })}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as BrowseViewResponseDto<AuditorRegistration>;
  return response;
};
